import { DataFile, fileType } from 'client/store/files/filesReducer'
import React, { useEffect } from 'react'
import { CheckCircleIcon } from 'src/editor/shared/icons/check-circle-icon'
import { File05Icon } from 'src/editor/shared/icons/file-05-icon'
import { XCloseIcon } from 'src/editor/shared/icons/x-close-icon'
import { Loader } from 'src/editor/shared/ui-lib/loader'
import { twJoin } from 'tailwind-merge'
import { getShortName } from './file-library'

interface UploadedFileProps {
  currentFile?: DataFile
  cancelUpload: () => void
  removeFile?: (fileId: number) => void
  onRemovingChange?: (isRemoving: boolean) => void
  removingFileId?: number
  progressInfo?: {
    total: number
    loaded: number
  }
}

export const UploadedFile = ({
  currentFile,
  cancelUpload,
  removeFile,
  removingFileId,
  progressInfo,
  onRemovingChange,
}: UploadedFileProps) => {
  const progress = progressInfo
    ? Math.round((progressInfo.loaded * 100) / progressInfo.total)
    : null
  const isCompleted = progress === 100
  const isRemoving = !!removingFileId && currentFile?.id === removingFileId

  useEffect(() => {
    if (onRemovingChange) {
      onRemovingChange(isRemoving)
    }
  }, [isRemoving, onRemovingChange])

  return (
    <div className="flex h-[38px] items-center justify-between gap-3">
      {currentFile?.type === fileType.image ? (
        <img
          className="h-[38px] w-[38px] rounded-md object-cover"
          src={currentFile?.path}
          alt={currentFile?.name}
        />
      ) : (
        <File05Icon width={38} height={38} />
      )}
      <div className="flex flex-1 flex-col justify-center">
        <div className="flex items-center justify-between">
          <span
            className={twJoin(
              'w-1/2 overflow-hidden text-ellipsis whitespace-nowrap font-semibold text-M',
              isRemoving && 'text-textDisabled',
            )}
          >
            {getShortName(currentFile?.name || '', 20, 15)}
          </span>
          {progressInfo && !isCompleted && <span>{progress} %</span>}
        </div>
        {progressInfo && !isCompleted && (
          <div className="mt-2 h-1 overflow-hidden rounded-full bg-bgSecondary">
            <div
              className="h-1 rounded-full bg-primary-500"
              style={{ width: `${progress}%` }}
            />
          </div>
        )}
      </div>
      <div className="flex items-center gap-3">
        {!!currentFile && (
          <button type="button" disabled className="mr-3">
            <CheckCircleIcon className="fill-iconSuccess" />
          </button>
        )}
        {isRemoving ? (
          <Loader className="h-5 w-5" />
        ) : (
          <button
            type="button"
            disabled={isRemoving}
            onClick={() => {
              currentFile ? removeFile?.(currentFile.id) : cancelUpload()
            }}
            className="cursor-pointer text-textSecondary"
          >
            <XCloseIcon className="fill-iconSecondary" />
          </button>
        )}
      </div>
    </div>
  )
}
